import { Box, Typography } from '@mui/material'
import { APP_VERSION } from '../constants'

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e0e0e0',
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" color="textSecondary">
        v{APP_VERSION}
      </Typography>
    </Box>
  )
}
